/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ArrowAngleLeftDownIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABDklEQVR4nGNgGAX0Ar4BEUf9/MMP08wCv4CI/yA8asHABJGHRzQfxILwjyRptLe3Z/Hw8GAnpM7PL8IQZIGvf8Q1og338YkU8fOPOOsXEPGEkCV+AeF10CCaSbzhAeEXwZr8I86GhoYy41IbGhrK7xcQ/hrsg8AIJ5IM9w0Iv+QRGiqKRzmjn3/EWojaiH2kuvwyPsPBLocZ7h/x1tc3VIV4wwPCrwQGxohhMZTHJzDMCBLm0GDxj3jr7x9uS9D1vgHhJ2BpmVjsGxCxj6DL4Rb4h58kaKB/xGdQUgSlFqIiFBmAwhsUqZDwD7/uFRoqQZIBI88SP/+Iy7CMBkrvtLLkLChS6+vrmahuwZABAI0yu+5QU1PJAAAAAElFTkSuQmCC)
 */
export const ArrowAngleLeftDownIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2.3 16.7a1 1 0 0 1 0-1.4l5-5a1 1 0 1 1 1.4 1.4L5.42 15H11a7 7 0 0 0 7-7V4a1 1 0 1 1 2 0v4a9 9 0 0 1-9 9H5.41l3.3 3.3a1 1 0 1 1-1.42 1.4l-5-5Z"
        className={colorClass}
      />
    </svg>
  );
};
